module.exports = __webpack_public_path__ + "img/logobj.088e656d.png";